import { Text } from '@capsicum/common-web';
import styled from 'styled-components';

import { TabContentContainer } from '../../feature/tabs/WCPledgeTabs.styled';

export type WCPledgeListNoPledgesPlaceholderProps = {
	bodyText?: string;
	testID: string;
	titleText: string;
};

export const WCPledgeListNoPledgesPlaceholderComponent = ({
	bodyText,
	testID,
	titleText
}: WCPledgeListNoPledgesPlaceholderProps) => {
	return (
		<S.StyledTabContentContainer>
			<Text style={{ textAlign: 'center' }} testID={testID + '-title'} variant="text1">
				{titleText}
			</Text>
			<Text style={{ textAlign: 'center' }} testID={testID + '-bodyText'} variant="text5">
				{bodyText}
			</Text>
		</S.StyledTabContentContainer>
	);
};

export namespace S {
	export const StyledTabContentContainer = styled(TabContentContainer)`
		gap: ${({ theme }) => theme.spacings.large};
		display: flex;
		flex-direction: column;
	`;
}
